// @ts-nocheck
import React, { ReactDOM } from "react";
import styled from "styled-components/macro";
import { MEDIA_WIDTHS } from "theme";

import { Token } from "@uniswap/sdk-core";

import { ReactComponent as DropDown } from "../../assets/images/dropdown.svg";
import CurrencyLogo from "../CurrencyLogo";
import { ActivatorButton, DropdownList, Wrapper } from "./styles";

const StyledDropDown = styled(DropDown)<{ selected: boolean }>`
  margin: 0 0.25rem 0 0.35rem;
  height: 35%;

  path {
    stroke: ${({ selected, theme }) => (selected ? theme.white : theme.white)};
    stroke-width: 1.5px;
  }
`

const NetworkLabel = styled.div`
  flex: 1 1 auto;
  color: white;
  overflow: hidden;
  height: 24px;
  font-size: 16px;
`
const SelectorLabel = styled(NetworkLabel)`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: white;
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {
    display: block;
    margin-right: 8px;
  }
`
const FlyoutRow = styled.button<{ active: boolean }>`
  align-items: center;

  background-color: ${({ active, theme }) => (active ? 'rgb(47 42 60)' : 'transparent')};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-weight: 600;
  justify-content: space-between;
  padding: 6px 8px;
  text-align: left;
  width: 100%;
  border: none;
`
const ActiveRowWrapper = styled.div`

  background-color: rgb(60, 60, 60);

  border-radius: 8px;
  cursor: pointer;
  padding: 0px;
  width: 100%;
`
const FlyoutMenu = styled.div`
  background: linear-gradient(73.6deg, #85FFC4 2.11%, #5CC6FF 42.39%, #BC85FF 85.72%);
  border: none;
  padding: 1px;
  position: absolute;
  border-radius: 20px;
  min-width: 160px;
  z-index: 99;
  @media screen and (min-width: ${MEDIA_WIDTHS.upToSmall}px) {

  }
`
const FlyoutMenuContents = styled.div`
  align-items: flex-start;
  background-color: rgb(31 30 34);
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 16px 24px rgba(0, 0, 0, 0.04),
  0px 24px 32px rgba(0, 0, 0, 0.01);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  overflow: auto;
  padding: 12px;

  & > *:not(:last-child) {
    margin-bottom: 12px;
  }
`

interface IProps {
  onUserClick: (currency: Token) => void
  selected?: Token;
  children: ReactDOM,
  items: Token[];
  disabled: boolean;
}

export default function CurrencyDropdown({
  onUserClick,
  selected,
  items,
  children,
  disabled = false
}: IProps) {
  const activatorRef = React.useRef<HTMLButtonElement | null>(null)
  const listRef = React.useRef<HTMLUListElement | null>(null)
  const [isOpen, setIsOpen] = React.useState(false)
  const [activeIndex, setActiveIndex] = React.useState(-1)
  const handleClick = () => {
    if (disabled) return
    setIsOpen(!isOpen)
  }
  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('mouseup', handleClickOutside)
    } else {
      document.removeEventListener('mouseup', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mouseup', handleClickOutside)
    }
  }, [isOpen])
  const keyHandler = (event: React.KeyboardEvent) => {
    if (isOpen) {
      switch (event.key) {
        case 'Escape':
          setIsOpen(false)
          break
        case 'ArrowDown':
          const nodeList = listRef.current!.querySelectorAll('a')
          if (activeIndex === items.length - 1) return
          nodeList[activeIndex + 1].focus()
          break
        case 'ArrowUp':
          const nodeList2 = listRef.current!.querySelectorAll('a')
          if (activeIndex === 0) return
          nodeList2[activeIndex - 1].focus()
          break
      }
    }
  }
  const handleClickOutside = (event: any) => {
    if (
      listRef.current!.contains(event.target) ||
      activatorRef.current!.contains(event.target)
    ) {
      return
    }
    setIsOpen(false)
  }
  const userClick = (currency: Token) => {
    onUserClick(currency)
    setIsOpen(false)
  }

  function Row({
    active,
    currency,
  }: {
    active: boolean
    currency: Token
  }) {
    const rowContent = (
      <FlyoutRow active={active} onClick={() => userClick(currency)}>
        <CurrencyLogo style={{ marginRight: '0.5rem' }} currency={currency} size={'32px'} />
        <NetworkLabel>{currency?.symbol}</NetworkLabel>
      </FlyoutRow>
    )
    if (active) {
      return (
        <ActiveRowWrapper>
          {rowContent}
        </ActiveRowWrapper>
      )
    }
    return rowContent
  }

  React.useEffect(() => {
    if (!isOpen) {
      setActiveIndex(-1)
    }
  }, [isOpen])


  return (
    <Wrapper onKeyUp={keyHandler} style={{ opacity: (disabled ? 0.45 : 1), marginRight: 0 }}>
      
        <ActivatorButton
          aria-haspopup='true'
          aria-controls='dropdown1'
          onClick={handleClick}
          ref={activatorRef}
          onFocus={() => setActiveIndex(-1)}
          style={{ width: "160px", textAlign: "left" }}
        >
          {selected === null ?
            <SelectorLabel style={{margin: "0 4px"}}>{"Select a Token"}</SelectorLabel>
          :  
            <>
            {children}
            <SelectorLabel style={{margin: "0 4px"}}>{(selected?.symbol)}</SelectorLabel>
            </>
          } 
          <StyledDropDown selected={!!selected} />
        </ActivatorButton>
        
      

      <DropdownList id='dropdown1' ref={listRef} active={isOpen} role='list' style={{padding: "3px 0"}}>
        <FlyoutMenu>
          <FlyoutMenuContents>
            {
              items.length > 0 &&
              items?.map((item) => {
                return (
                  <Row key={item.address} active={selected?.address === item?.address} currency={item} />
                )
              })
            }
          </FlyoutMenuContents>
        </FlyoutMenu>
      </DropdownList>
    </Wrapper>
  )
};
